var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"scrollToTop",on:{"click":function($event){return _vm.scrollToTop()}}},[_c('img',{staticClass:"scrollToTop__img",attrs:{"alt":"arrowUp","src":require("@/assets/img/common/arrowUp.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }